"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    REACH: 'Reach',
    TARGET: 'Target',
    SAFETY: 'Safety',
    HARD: 'Hard',
};
//# sourceMappingURL=goalType.js.map